import * as CertificationWatermark from '@tableau/certification-watermark';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { ExplorerStyles } from '../../../components/Explorer/ExplorerStyles';
import { StyledCellFormatter } from '../StyledCellWrapper';

export interface ContentTypeCellOptions {
  iconTypeForRow: (row: DataGrid.Row) => (props: any) => React.ReactSVGElement | null;
  titleForIcon: (row: DataGrid.Row) => string;
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps;
}

export const ContentTypeCell = (options: ContentTypeCellOptions): React.StatelessComponent<BodyCell.Props> => {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render(): JSX.Element {

          const icon = options.iconTypeForRow(this.props.row);

          return (
              <div className={ExplorerStyles.ContentTypeCellContainer}>
                <span className={ExplorerStyles.ContentTypeCellImg}>
                  {icon && icon({size: ExplorerStyles.contentTypeIconSize, alt: options.titleForIcon(this.props.row)})}
                </span>
              </div>
          );
        }
      })
  );
};
